<template lang="pug">
  .rate-item-container
    .rate__total
        span {{ $t('综合评分') }}:
        span {{ item.overall | formatRate }}
    .rate__detail
      .rate-items(style="margin-bottom: 16px")
        span.rate__title {{ $t('客户满意度') }}:
        el-rate(
          v-model="item.satisfaction"
          disabled
          text-color="#f7a04c"
          score-template="{value}"
        )
        span.rate__number {{ item.satisfaction | formatRate }}
      .rate-items
        span.rate__title {{ $t('创意能力') }}:
        el-rate(
          v-model="item.creativity"
          disabled
          text-color="#f7a04c"
          score-template="{value}"
        )
        span.rate__number {{ item.creativity | formatRate }}
    .rate__detail
      .rate-items(style="margin-bottom: 16px")
        span.rate__title {{ $t('执行能力') }}:
        el-rate(
          v-model="item.execution"
          disabled
          text-color="#f7a04c"
          score-template="{value}"
        )
        span.rate__number {{ item.execution | formatRate }}
      .rate-items
        span.rate__title {{ $t('成本控制') }}:
        el-rate(
          v-model="item.cost_control"
          disabled
          text-color="#f7a04c"
          score-template="{value}"
        )
        span.rate__number {{ item.cost_control | formatRate }}
    .rate__detail
      .rate-items
        span.rate__title {{ $t('开发能力') }}:
        el-rate(
          v-model="item.development"
          disabled
          text-color="#f7a04c"
          score-template="{value}"
        )
        span.rate__number {{ item.development | formatRate }}
</template>

<script>
import { formatRate } from '@/umcc/util'

export default {
  filters: {
    formatRate
  },
  props: {
    item: {
      type: Object,
      default () {
        return {
          list: []
        }
      }
    }
  }
}
</script>

<style lang="stylus">
.rate-item-container
  margin-top 15px
  display flex
  box-sizing border-box
  justify-content space-between
  .rate__total
    width 200px
    margin-right 57px
    display flex
    justify-content center
    align-items center
    span
      &:first-child
        color #8c8c8c
      &:last-child
        color rgb(247, 186, 42)
        font-size 32px
        font-weight normal
        margin-left 5px
  .rate__detail
    width 30%
    &:last-child
      align-self baseline
  .rate-items
    display flex
    align-items center
    .rate__title
      color $gray1
      margin-right 3px
      min-width 110px
      text-align right
    .rate__number
      color $rate-text
</style>
